import { HTTP } from '@/api/http-common'
import { HttpFunctions } from '@/api/http-functions'

export default {
  setPaymentStatus (callback, body) {
    HTTP.put('payment', body).then(response => {
      if (response.status === 201) {
        callback(response)
      } else if (response.status === 403) {
        console.log('Error: pdo error missing')
      } else if (response.status === 401) {
        HttpFunctions.response401()
      } else if (response.status === 400) {
        console.log('Error: method&status are required')
      }
    }).catch(e => {
      console.log(e)
    })
  },
  setOmiseKey (callback, body) {
    HTTP.put('payment', body).then(response => {
      if (response.status === 201) {
        callback(response)
      } else if (response.status === 401) {
        HttpFunctions.response401()
      } else if (response.status === 400) {
        console.log('Error: Public Key or Secret Key is missing')
      }
    }).catch(e => {
      console.log(e)
    })
  },
  getOmise (callback) {
    HTTP.get('payment/omise').then(response => {
      if (response.status === 201) {
        callback(response)
      } else if (response.status === 401) {
        HttpFunctions.response401()
      }
    }).catch(e => {
      console.log(e)
    })
  },
  setPaypalKey (callback, body) {
    HTTP.put('payment', body).then(response => {
      if (response.status === 201) {
        callback(response)
      } else if (response.status === 401) {
        HttpFunctions.response401()
      } else if (response.status === 400) {
        console.log('Error: Client ID or Secret Key is missing')
      }
    }).catch(e => {
      console.log(e)
    })
  },
  getPaypal (callback) {
    HTTP.get('payment/paypal').then(response => {
      if (response.status === 201) {
        callback(response)
      } else if (response.status === 401) {
        HttpFunctions.response401()
      }
    }).catch(e => {
      console.log(e)
    })
  },
  getPaymentStatus (callback) {
    HTTP.get('payment').then(response => {
      if (response.status === 201) {
        callback(response)
      } else if (response.status === 401) {
        HttpFunctions.response401()
      }
    }).catch(e => {
      console.log(e)
    })
  },
  getPaymentCurrencies (callback, body) {
    HTTP.get('/properties/currency?payment=' + body).then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 403) {
        console.log('Error: pdo error missing')
      } else if (response.status === 401) {
        HttpFunctions.response401()
      }
    }).catch(e => {
      console.log(e)
    })
  },
  getCheckPaymentCurrency (callback, body) {
    HTTP.get('/payment/check').then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 403) {
        console.log('Error: pdo error missing')
      } else if (response.status === 401) {
        HttpFunctions.response401()
      }
    }).catch(e => {
      console.log(e)
    })
  },
  setTransferText (callback, body) {
    HTTP.put('payment', body).then(response => {
      if (response.status === 201) {
        callback(response)
      } else if (response.status === 401) {
        HttpFunctions.response401()
      } else if (response.status === 400) {
        console.log('Error: Manual Label is missing')
      }
    }).catch(e => {
      console.log(e)
    })
  },
  updatePaymentStatus (callback, body) {
    HTTP.put('payment/status', body).then(response => {
      if (response.status === 201) {
        callback(response)
      } else if (response.status === 403) {
        console.log('Error: pdo error missing')
      } else if (response.status === 401) {
        HttpFunctions.response401()
      } else if (response.status === 400) {
        console.log('Error: method&status are required')
      }
    }).catch(e => {
      console.log(e)
    })
  },
  getPaymentLists (callback) {
    HTTP.get('payment/lists').then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 401) {
        HttpFunctions.response401()
      }
    }).catch(e => {
      console.log(e)
    })
  },
  setPaymentSort (callback, body) {
    HTTP.put('payment/sort', body).then(response => {
      if (response.status === 201) {
        callback(response)
      } else if (response.status === 401) {
        HttpFunctions.response401()
      }
    }).catch(e => {
      console.log(e)
    })
  },
  setPayment (callback, body) {
    HTTP.put('payment/custom', body).then(response => {
      if (response.status === 201) {
        callback(response)
      } else if (response.status === 401) {
        HttpFunctions.response401()
      }
    }).catch(e => {
      console.log(e)
    })
  },
  getPaymentCustom (callback, body) {
    HTTP.get('payment/custom?id=' + body).then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 401) {
        HttpFunctions.response401()
      }
    }).catch(e => {
      console.log(e)
    })
  },
  addPayment (callback, body) {
    if (body !== undefined) {
      HTTP.post('payment', body).then(response => {
        if (response.status === 201) {
          callback(response)
        } else if (response.status === 403) {
          console.log('Error: pdo error missing')
        } else if (response.status === 401) {
          HttpFunctions.response401()
        }
      }).catch(e => {
        console.log(e)
      })
    }
  },
  deletePaymentField (callback, body) {
    if (body !== undefined) {
      HTTP.delete('/payment', {data: {'payment_lists_id': body}}).then(response => {
        if (response.status === 200) {
          callback(response)
        } else if (response.status === 403) {
          console.log('Error: pdo error missing')
        } else if (response.status === 401) {
          HttpFunctions.response401()
        }
      }).catch(e => {
        console.log(e)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/payments/index.js